module.exports = __webpack_public_path__ + "img/cone-striped.de7906ca.svg";